import React, { useState } from "react";
import { FiSearch } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import userResources from "api/userResources";

export default function NavbarSearchAnyEnquirys() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = async (type) => {
    if (!searchTerm.trim()) {
      toast.warning("Please enter client phone number.");
      return;
    }

    try {
      if (type === "Flight") {
        navigate("/admin/search-enquiry", {
          state: searchTerm,
        });
      } else if (type === "Hotel") {
        // Call different API for hotel
        navigate("/admin/search-hotel-enquirys", {
          state: searchTerm,
        });
      }else if (type === "Package") {
        navigate("/admin/search-package-enquirys", {
          state: searchTerm,
        });
      }
       else if (type === "Other Services") {
        // Call different API for other services

        navigate("/admin/search-other-enquirys", {
          state: searchTerm,
        });
      }
      setSearchTerm(""); // Reset the search term
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to fetch search results."
      );
      console.error("API Error:", error);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (!searchTerm.trim()) {
        // Show warning if input is empty
        toast.warning("Please enter a phone number to search.");
        return;
      }

      // Show a toast to prompt user to select the enquiry type
      const toastId = toast.info(
        <div className="text-left">
          <p>Select the type of enquiry:</p>
          <div className="justify-left mt-2 flex items-center gap-4">
            <button
              className="btn btn-primary text-xs text-white"
              onClick={() => {
                handleSearch("Flight");
                toast.dismiss(toastId); // Close the toast after selection
              }}
            >
              Flight
            </button>
            <button
              className="btn btn-secondary text-xs text-white"
              onClick={() => {
                handleSearch("Hotel");
                toast.dismiss(toastId); // Close the toast after selection
              }}
            >
              Hotel
            </button>
            {/* <button
              className="btn bg-orange-500 text-xs text-white"
              onClick={() => {
                handleSearch("Package");
                toast.dismiss(toastId); // Close the toast after selection
              }}
            >
              Package
            </button> */}
            <button
              className="btn btn-success text-xs text-white"
              onClick={() => {
                handleSearch("Other Services");
                toast.dismiss(toastId); // Close the toast after selection
              }}
            >
              Other
            </button>
          </div>
        </div>,
        {
          position: "top-center",
          autoClose: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          style: { width: "400px" }, // <-- custom width here
        }
      );
    }
  };

  return (
    <>
      {/* Search Bar */}
      <section className="flex h-full w-full items-center overflow-hidden rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white">
        <p className="pl-3 pr-2 text-xl">
          <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
        </p>
        <input
          type="number"
          placeholder="Search enquiry by Number..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={handleKeyDown}
          className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
        />
      </section>
    </>
  );
}
